import {
  Add,
  ArticleOutlined,
  AssessmentOutlined,
  FilterListOutlined,
  HandshakeOutlined,
  ShoppingBagOutlined,
  UploadFileOutlined,
  ViewHeadlineOutlined,
} from '@mui/icons-material';
import { Divider, List } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { NavCollapse, NavDrawerProps } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';
import { useMatch } from 'react-router-dom';

import { NavId, NegotiationDomainType } from '~/common/types';
import { FiltersNavList } from '~/components/FiltersNavList/FiltersNavList';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { NavSubListItemLink } from '~/components/NavSubListItemLink/NavSubListItemLink';
import { RouteId } from '~/routes/RouteId';

export const NegotiationDemandListDrawer = (props: NavDrawerProps) => {
  return (
    <NavDrawerSimple navId={NavId.demand} {...props}>
      <Restricted needs={{ permission: Permission.DemandList }}>
        <NavCollapse
          in
          icon={<ShoppingBagOutlined />}
          label={<Trans i18nKey={`Nav.${NavId.demand}`} />}
          sx={{ marginBottom: 4 }}
        >
          <List>
            <NavSubListItemLink
              id={NavId.demandDemands}
              to={RouteId.demand}
              selected={!!useMatch({ path: RouteId.demand, end: true })}
              Icon={ViewHeadlineOutlined}
            />
            <FiltersNavList domain={NegotiationDomainType.DEMAND} Icon={FilterListOutlined} showDot />
          </List>
        </NavCollapse>
      </Restricted>
      <Divider />
      {/** Contract Demand */}
      <Restricted needs={{ permission: Permission.ContractDemandList }}>
        <NavCollapse
          in
          icon={<ShoppingBagOutlined />}
          label={<Trans i18nKey={`Nav.${NavId.contractDemand}`} />}
          sx={{ marginBottom: 4 }}
        >
          <List>
            <NavSubListItemLink
              id={NavId.contractDemands}
              to={RouteId.contractDemand}
              selected={!!useMatch({ path: RouteId.contractDemand, end: true })}
              Icon={ViewHeadlineOutlined}
            />
            <NavSubListItemLink
              id={NavId.coverageAssistant}
              to={RouteId.coverageAssistant}
              selected={!!useMatch({ path: RouteId.coverageAssistant, end: true })}
              Icon={AssessmentOutlined}
            />
            <FiltersNavList domain={NegotiationDomainType.CONTRACT_DEMAND} Icon={FilterListOutlined} showDot />
          </List>
        </NavCollapse>
      </Restricted>
      <Divider />
      <Restricted needs={{ permission: Permission.CaseList }}>
        <NavCollapse
          in
          icon={<HandshakeOutlined />}
          label={<Trans i18nKey={`Nav.${NavId.negotiation}`} />}
          sx={{ marginBottom: 4 }}
        >
          <List>
            <NavSubListItemLink
              id={NavId.demandNegotiationCases}
              to={RouteId.negotiationCases}
              selected={!!useMatch({ path: RouteId.negotiationCases, end: true })}
              Icon={ViewHeadlineOutlined}
            />
            <FiltersNavList domain={NegotiationDomainType.NEGOTIATION_CASE} Icon={FilterListOutlined} showDot />
          </List>
        </NavCollapse>
      </Restricted>
      <Restricted needs={{ permission: { any: [Permission.DemandManualCreate, Permission.IntakeCreate] } }}>
        <Divider />

        <NavCollapse in icon={<Add />} label={<Trans i18nKey={`Nav.${NavId.demandAdd}`} />} sx={{ marginBottom: 4 }}>
          <List>
            <NavSubListItemLink
              id={NavId.demandCreate}
              to={RouteId.demandCreate}
              Icon={ArticleOutlined}
              needs={{ permission: Permission.DemandManualCreate }}
            />
            <NavSubListItemLink
              id={NavId.demandIntakeCreate}
              to={RouteId.intakeCreate}
              Icon={UploadFileOutlined}
              needs={{ permission: Permission.IntakeCreate }}
            />
          </List>
        </NavCollapse>
      </Restricted>
    </NavDrawerSimple>
  );
};
